var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrvMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2401_24689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99002 2.27286C9.06002 2.27286 10.06 2.69286 10.82 3.44286C11.9 4.52286 12.26 6.16286 11.74 7.62286C11.62 7.93286 11.5 8.19286 11.38 8.38286L11.27 8.55286L7.99002 13.4729L4.70002 8.55286L4.62002 8.41286C4.47002 8.19286 4.35002 7.93286 4.24002 7.62286C3.72002 6.16286 4.08002 4.52286 5.16002 3.44286C5.91002 2.69286 6.92002 2.27286 7.99002 2.27286ZM7.99002 0.272858C6.39002 0.272858 4.88002 0.892858 3.74002 2.03286C2.05002 3.72286 1.60002 6.18286 2.36002 8.29286C2.50002 8.71286 2.69002 9.11286 2.93002 9.49286L3.04002 9.66286L7.15002 15.8329C7.35002 16.1229 7.67002 16.2729 7.99002 16.2729C8.31002 16.2729 8.62002 16.1229 8.82002 15.8329L12.93 9.66286L13.04 9.49286C13.28 9.11286 13.46 8.71286 13.61 8.30286C14.37 6.18286 13.92 3.73286 12.22 2.03286C11.1 0.892858 9.59002 0.272858 7.99002 0.272858ZM9.99002 6.27286C9.99002 5.17286 9.09002 4.27286 7.99002 4.27286C6.89002 4.27286 5.99002 5.17286 5.99002 6.27286C5.99002 7.37286 6.89002 8.27286 7.99002 8.27286C9.09002 8.27286 9.99002 7.37286 9.99002 6.27286Z",
    fill: "#0070A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2401_24689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17.4545,
    fill: "white",
    transform: "translate(0 0.272858)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrvMapPin);
export default __webpack_public_path__ + "static/media/grv-map-pin.a192e24809799a7c3bc4b70a5ed1f48d.svg";
export { ForwardRef as ReactComponent };